jQuery(document).ready(function () {
    try {
        var $button = jQuery("button.categories-title__button");
        var $content = jQuery("nav.header__menu-vertical");
        $button.attr("aria-expanded", "false");
        $button.on("click", function () {
            var isExpanded = jQuery(this).attr("aria-expanded") === "true";
            jQuery(this).attr("aria-expanded", !isExpanded);
            $content.toggleClass("dropdown-menu-toggle", !isExpanded);
            $button.toggleClass("main-menu-toggle");
        });
        jQuery("div.vertical-menu").on("mouseenter", function () {
            $button.attr("aria-expanded", "true");
        });
        jQuery("div.vertical-menu").on("mouseleave", function () {
            $button.attr("aria-expanded", "false");
        });
        jQuery(".icon-dropdown.toggle-btn").attr("aria-expanded", "false");
        jQuery(".no-megamenu.dropdown").hover(
            function () {
                jQuery(this).find(".icon-dropdown.toggle-btn").attr("aria-expanded", "true");
            },
            function () {
                jQuery(this).find(".icon-dropdown.toggle-btn").attr("aria-expanded", "false");
            }
        );
        jQuery("body").on("keyup", ".list-menu > .menu-lv-item.menu-lv-item.no-megamenu", function (e) {
            if (e.keyCode == 9) {
                jQuery(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu").not(this).removeClass("is-focused-active");
                jQuery(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu").not(this).find("button").attr("aria-expanded", "false");
            }
        });
        jQuery("body").on("keydown", function (e) {
            const $target = $(e.target);
            if (e.key === "Enter") {
                if ($target.is(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu.dropdown a + button")) {
                    const isExpanded = $target.attr("aria-expanded") === "true";
                    $target.attr("aria-expanded", !isExpanded);
                    $target.closest("li").toggleClass("is-focused-active", !isExpanded);
                    e.preventDefault();
                } else if ($target.is(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu.dropdown a + button") && !$target.find("button").length) {
                    window.location.href = $target.attr("href");
                }
            } else if (e.key === "Escape") {
                if ($target.is(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu.dropdown >ul  li a, .list-menu > .menu-lv-item.menu-lv-item.no-megamenu.dropdown a + button")) {
                    const $parentDropdown = $target.closest(".no-megamenu");
                    if ($parentDropdown.length) {
                        $parentDropdown.removeClass("is-focused-active");
                        jQuery(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu.dropdown").removeClass("is-focused-active");
                        const $button = $parentDropdown.find("button");
                        if ($button.length) {
                            $button.focus().attr("aria-expanded", "false");
                        }
                    }
                }
            }
        });
        function closeAllMenus() {
            jQuery(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu").removeClass("is-focused-active").find("button").attr("aria-expanded", "false");
        }
        jQuery(".list-menu > .menu-lv-item.menu-lv-item.no-megamenu.dropdown a + button").on("keyup", function (e) {
            if (e.shiftKey) {
                closeAllMenus();
            }
        });
        var $menuLinks = jQuery("nav.header__menu-vertical > ul > li > a[href], button.categories-title__button");
        $menuLinks.on("keydown", function (e) {
            if (e.keyCode === 27) {
                jQuery("nav.header__menu-vertical").removeClass("dropdown-menu-toggle");
                jQuery("button.categories-title__button").removeClass("main-menu-toggle").attr("aria-expanded", "false").focus();
            }
        });
        var $menuLink = jQuery("nav.header__menu-vertical > ul > li > a");
        $menuLink.on("focusout", function (e) {
            var relatedTarget = e.relatedTarget || document.activeElement;
            if (!jQuery(relatedTarget).closest("nav.header__menu-vertical").length) {
                jQuery("nav.header__menu-vertical").removeClass("dropdown-menu-toggle");
                jQuery("button.categories-title__button").attr("aria-expanded", "false");
                jQuery("button.categories-title__button").removeClass("main-menu-toggle");
            }
        });
    } catch (error) {}
    try {
        jQuery(".customer-review__left .halo-block-header .subtext-review a").attr("aria-label", "See more Reviews & Press Highlights");
    } catch (error) {}
    try {
        setTimeout(function () {
            jQuery(".slick-prev.slick-arrow").each(function () {
                jQuery(this).attr("aria-label", "Previous Slide");
            });
            jQuery(".slick-next.slick-arrow").each(function () {
                jQuery(this).attr("aria-label", "Next Slide");
            });
        }, 2000);
    } catch (error) {}
    try {
        jQuery(".halo-item a.adaptive_height").attr("tabindex", "-1");
    } catch (error) {}
    try {
        jQuery(".btn-group.currency-dropdown.shopify-currency:eq(0)").attr("role", "button").attr("aria-expanded", "false");
        jQuery(".slick-prev.slick-arrow").each(function () {
            jQuery(this).attr("aria-label", "Previous Slide");
        });
        jQuery(".slick-next.slick-arrow").each(function () {
            jQuery(this).attr("aria-label", "Next Slide");
        });
        function toggleCurrencyDropdown() {
            if (!jQuery(".top-language-currency.enable-currency").hasClass("show")) {
                jQuery(".top-language-currency.enable-currency").addClass("show");
                jQuery(".dropdown-currency").addClass("show");
                jQuery(".btn-group.currency-dropdown.shopify-currency:eq(0)").attr("aria-expanded", "true");
            } else {
                jQuery(".btn-group.currency-dropdown.shopify-currency:eq(0)").attr("aria-expanded", "false");
                jQuery(".top-language-currency.enable-currency").removeClass("show");
                jQuery(".dropdown-currency").removeClass("show");
            }
        }
        var firstCurrency = jQuery('.dropdown-menu.currency-menu a[data-currency="CAD"]');
        var lastCurrency = jQuery('.dropdown-menu.currency-menu a[data-currency="USD"]');
        lastCurrency.on("keydown", function (event) {
            if (event.keyCode === 9) {
                jQuery(".btn-group.currency-dropdown.shopify-currency:eq(0)").attr("aria-expanded", "false");
                jQuery(".top-language-currency.enable-currency").removeClass("show");
                jQuery(".dropdown-currency").removeClass("show");
            }
        });
        firstCurrency.on("keydown", function (event) {
            if (event.shiftKey) {
                jQuery(".btn-group.currency-dropdown.shopify-currency:eq(0)").attr("aria-expanded", "false");
                jQuery(".top-language-currency.enable-currency").removeClass("show");
                jQuery(".dropdown-currency").removeClass("show");
            }
        });
        jQuery(".btn-group.currency-dropdown.shopify-currency").on("keydown", function (event) {
            if (event.keyCode === 13) {
                toggleCurrencyDropdown();
            }
        });
        jQuery(".btn-group.currency-dropdown.shopify-currency").on("click", function () {
            const $dropdown = jQuery(".btn-group.currency-dropdown.shopify-currency:eq(0)");
            const isExpanded = $dropdown.attr("aria-expanded") === "true";
            $dropdown.attr("aria-expanded", isExpanded ? "false" : "true");
        });
    } catch (error) {}

    jQuery(".p-note").each(function () {
        const noteText = jQuery(this).clone().children().remove().end().text().replace(/here|click|\./gi, "").trim();
        const dynamicText = `Click here ${noteText}`;
        jQuery("div.variant_list a").attr("aria-label", dynamicText);
    });

    const intervalId = setInterval(function () {
        const $button = jQuery("div#widget-fave-html .ssw-fave-btn");
        if ($button.length > 0) {
            $button.removeAttr("role");
            clearInterval(intervalId);
        }
        const $carousel = jQuery(".productView-thumbnail-wrapper.is-hidden-mobile.arrows-visible .slick-slider");
        if ($carousel.length > 0) {
            $carousel.attr({
                role: "region",
                "aria-label": "Product images Carousel",
            });
            // clearInterval(intervalId);
        }
        var pageUrl = window.location.href;
        var pageTitle = document.title;
        if (pageUrl.includes("membership")) {
            var newTitle = "Membership - " + pageTitle.replace(/-.+/, "").trim();
            document.title = newTitle;
            // clearInterval(intervalId);
        }
         
        jQuery("header a.header__icon--cart").on("click", function () {
            jQuery("div.rebuy-cart__flyout-subtotal-amount").attr("aria-live", "polite");
            jQuery(".rebuy-product-block").each(function () {
                jQuery(this).removeAttr("role").removeAttr("aria-label");
                clearInterval(intervalId);
            });
            jQuery(".rebuy-product-price span").removeAttr("tabindex");
            jQuery("a.rebuy-cart__flyout-item-product-title").removeAttr("role aria-level");
            jQuery(".rebuy-product-media a.rebuy-product-image, ul li .rebuy-cart__flyout-item-media a").attr({
                tabindex: "-1",
                "aria-hidden": "true",
            });

            jQuery(".rebuy-cart__flyout-subtotal-final-amount").each(function () {
                if ($(this).prev(".sr-only").length === 0) {
                    $(this).before('<span class="sr-only" style="position: absolute; left: -9999px;">Sale Price</span>');
                }
            });

            jQuery(".rebuy-cart__flyout-subtotal-compare-amount").each(function () {
                if ($(this).prev(".sr-only").length === 0) {
                    $(this).before('<span class="sr-only" style="position: absolute; left: -9999px;">Regular Price</span>');
                }
            });
        });
        jQuery(".inveterate__benefits__list .inveterate__benefits__icon").each(function () {
            jQuery(this).attr("alt", "");
            clearInterval(intervalId);
        });
        // jQuery(".shopify-section.sections-slide-show ul li").removeAttr("aria-hidden").removeAttr("aria-selected");
        jQuery(".shopify-section.sections-slide-show ul li button").attr("role", "tab");
        jQuery(".slideshow .slick-track .slick-slide").each(function () {
            var $slide = jQuery(this);
            var sliderID = $slide.attr("id");
            if (!sliderID) {
                $slide.removeAttr("id");
            } else {
                jQuery(".slideshow .slick-dots li button").each(function (index) {
                    // if (index === $slide.index()) {
                    jQuery(this).attr("aria-controls", sliderID);
                    // }
                });
            }
        });
    }, 500); // Check every 500 milliseconds
    jQuery("#tab-shipping-amp-returns h3").each(function () {
        const $h3 = jQuery(this);
        const $h2 = jQuery("<h2></h2>").html($h3.html());
        $h3.replaceWith($h2);
    });

    jQuery(".variant_list.container .list p.MsoNormal").each(function () {
        const $p = jQuery(this);
        const $h3 = jQuery("<h3></h3>").addClass($p.attr("class")).html($p.html());
        $p.replaceWith($h3);
    });
    jQuery(".productView-thumbnail-wrapper.is-hidden-mobile.arrows-visible").attr({
        role: "region",
        "aria-label": "Product images Carousel",
    });
    jQuery(".shopify-section.spaced-section table").attr("role", "presentation");
    setTimeout(function () {
        const $heroHeading = $(".inveterate__hero__heading");
        const headingText = $heroHeading.text();
        const className = $heroHeading.attr("class");
        $heroHeading.replaceWith(`<h1 class="${className}">${headingText}</h1>`);
      
        const $blockHeading = $(".inveterate__pricing__block__heading");
        const h3Text = $blockHeading.find("h3").text();
        const pText = $blockHeading.find("p").text();
        $blockHeading.find("h3").replaceWith(`<span>${h3Text}</span>`);
        $blockHeading.find("p").replaceWith(`<h3>${pText}</h3>`);
      
        const $benefitsHeading = $(".inveterate__benefits__heading");
        const benefitsheadingText = $benefitsHeading.text();
        const benefitsclassName = $benefitsHeading.attr("class");
        $benefitsHeading.replaceWith(`<h2 class="${benefitsclassName}">${benefitsheadingText}</h2>`);

        const $pricingHeading = $(".inveterate__pricing__heading");
        const pricingheadingText = $pricingHeading.text();
        const pricingclassName = $pricingHeading.attr("class");
        $pricingHeading.replaceWith(`<h2 class="${pricingclassName}">${pricingheadingText}</h2>`);
      
        const $faqHeading = $(".inveterate__faqs__heading");
        const faqheadingText = $faqHeading.text();
        const faqclassName = $faqHeading.attr("class");
        $faqHeading.replaceWith(`<h2 class="${faqclassName}">${faqheadingText}</h2>`);

        jQuery("h4.inveterate__benefits__name").each(function () {
            const headingText = jQuery(this).text();
            const className = jQuery(this).attr("class");
            jQuery(this).replaceWith(`<h3 class="${className}">${headingText}</h3>`);
        });

        jQuery("a.view_all").each(function () {
            var ariaLabel = jQuery(this).attr("aria-labelledby");
            if (ariaLabel === "new--upcoming-releases") {
                var newId = "view-all-1";
                jQuery(this).attr("id", newId);
                jQuery(this).attr("aria-labelledby", newId + " new--upcoming-releases");
            }
            if (ariaLabel === "best-sellers") {
                var newId = "view-all-4";
                jQuery(this).attr("id", newId);
                jQuery(this).attr("aria-labelledby", newId + " best-sellers");
            }

            if (ariaLabel === "site-exclusives--gifts-with-purchase") {
                var newId = "view-all-3";
                jQuery(this).attr("id", newId);
                jQuery(this).attr("aria-labelledby", newId + " site-exclusives--gifts-with-purchase");
            }
        });
        const altText = ["krampus", "the-wolfman-collectors-edition-2-exclusive-posters-exclusive-slipcover", "the-blob-limited-edition-steelbook-exclusive-poster", "rock-n-roll-high-school-45th-anniversary-edition-exclusive-poster"];

        $(".spotlight-block img").each(function (index) {
            $(this).attr("alt", altText[index]);
        });
    }, 2000);
    const $checkboxLabel = jQuery("label.form-label--checkbox");
    const toggleAriaChecked = function () {
        const isChecked = $checkboxLabel.attr("aria-checked") === "true";
        $checkboxLabel.attr("aria-checked", isChecked ? "false" : "true");
    };

    $checkboxLabel.on("click", function () {
        toggleAriaChecked();
    });
    const $checkboxTick = jQuery("#accepts-marketing");
    $checkboxLabel.on("keydown", function (e) {
        const key = e.key || e.which || e.keyCode; // Compatibility check
        if (key === "Enter" || key === 13) {
            const isChecked = $checkboxTick.prop("checked");
            $checkboxTick.prop("checked", !isChecked);
            $checkboxLabel.attr("aria-checked", !isChecked ? "true" : "false");
        }
    });
    try {
        function updateAriaLabels() {
            function applyResponsiveShadowDOMManipulations() {
                const screenWidth = window.innerWidth;
                if (screenWidth >= 320 && screenWidth <= 1024) {
                    jQuery("div.fast-ac-container:eq(2)").attr("id", "mobile-search");
                    const $shadowSearchHost = $("#mobile-search.fast-ac-container");

                    if ($shadowSearchHost.length > 0) {
                        const shadowSearchRoot = $shadowSearchHost[0].shadowRoot;
                        if (shadowSearchRoot) {
                            const $shadowSearchRoot = $(shadowSearchRoot);
                            $shadowSearchRoot.find("div.fast-ac-item.line-item").removeAttr("tabindex");
                            $shadowSearchRoot.find("div.fast-ac-item.line-item a").removeAttr("tabindex");
                            $shadowSearchRoot.find(".products.fast-wide-products a").removeAttr("role");
                            $shadowSearchRoot.find(".products.fast-wide-products a img").attr("alt", "");
                            const $headerElement = $shadowSearchRoot.find("header.header.fs-autocomplete-header");
                            if ($headerElement.length > 0) {
                                const $divElement = $("<div>");
                                $.each($headerElement[0].attributes, function () {
                                    $divElement.attr(this.name, this.value);
                                });
                                $divElement.html($headerElement.html());
                                $headerElement.replaceWith($divElement);
                            }
                            const $summeryElements = $shadowSearchRoot.find(".summery");
                            if ($summeryElements.length > 0) {
                                const $lastSummeryElement = $summeryElements.last();
                                const strongValue = $lastSummeryElement.find("strong").text();
                                const cleanedStrongValue = strongValue.replace(/"/g, "");
                                const newHref = `/pages/search-results?q=${encodeURIComponent(cleanedStrongValue)}`;
                                const $atag = $("<a>", {
                                    class: $lastSummeryElement.attr("class"),
                                    href: newHref,
                                    html: $lastSummeryElement.html(),
                                });
                                $lastSummeryElement.replaceWith($atag);
                                $summeryElements.not($lastSummeryElement).remove();
                            }
                        }
                    }
                }
            }
            applyResponsiveShadowDOMManipulations();
            $(window).resize(applyResponsiveShadowDOMManipulations);

            const shadowSearchHost = document.querySelector(".mobile-fast-ac-container + .fast-ac-container");
            if (shadowSearchHost) {
                const shadowSearchRoot = shadowSearchHost.shadowRoot;
                if (shadowSearchRoot) {
                    const $shadowSearchRoot = $(shadowSearchRoot);
                    $shadowSearchRoot.find("div.fast-ac-item.line-item").removeAttr("tabindex");
                    $shadowSearchRoot.find("div.fast-ac-item.line-item a").removeAttr("tabindex");
                    $shadowSearchRoot.find(".products.fast-wide-products a").removeAttr("role");
                    $shadowSearchRoot.find(".products.fast-wide-products a img").attr("alt", "");

                    const headerElement = shadowSearchRoot.querySelector("header.header.fs-autocomplete-header");
                    if (headerElement) {
                        const divElement = document.createElement("div");
                        Array.from(headerElement.attributes).forEach((attr) => divElement.setAttribute(attr.name, attr.value));
                        divElement.innerHTML = headerElement.innerHTML;
                        headerElement.replaceWith(divElement);
                    }
                    const $summeryElements = $shadowSearchRoot.find(".summery");
                    if ($summeryElements.length > 0) {
                        const $lastSummeryElement = $summeryElements.last();
                        const strongValue = $lastSummeryElement.find("strong").text();
                        const cleanedStrongValue = strongValue.replace(/"/g, "");
                        const newHref = `/pages/search-results?q=${encodeURIComponent(cleanedStrongValue)}`;
                        const $atag = $("<a>", {
                            class: $lastSummeryElement.attr("class"),
                            href: newHref,
                            html: $lastSummeryElement.html(),
                        });
                        $lastSummeryElement.replaceWith($atag);
                        $summeryElements.not($lastSummeryElement).remove();
                    }
                }
            }

            const shadowHost = document.querySelector("#fast-simon-serp-app");
            if (shadowHost) {
                const shadowRoot = shadowHost.shadowRoot;
                if (shadowRoot) {
                    const $shadowRoot = $(shadowRoot);
                    $shadowRoot.find(".fs-grid-view-icon, .fs-list-view-icon").each(function () {
                        const $originalDiv = $(this);
                        const button = $("<button>", {
                            class: $originalDiv.attr("class"),
                            "aria-label": $originalDiv.hasClass("fs-grid-view-icon") ? "Grid View" : "List View",
                            role: "button",
                            html: $originalDiv.html(),
                            css: {
                                background: "transparent",
                                border: "none",
                            },
                        });
                        $originalDiv.replaceWith(button);
                    });
                    $shadowRoot.find(".fs-grid-view-button button").each(function () {
                        $(this).find(".sr-only").remove();
                        if ($(this).closest(".fs-selected-mode").length) {
                            $(this).append('<span class="sr-only" style="position: absolute; left: -9999px;">selected</span>');
                        }
                    });
                    $shadowRoot.find(".fs-list-view-button button").each(function () {
                        $(this).find(".sr-only").remove();
                        if ($(this).closest(".fs-selected-mode").length) {
                            $(this).append('<span class="sr-only" style="position: absolute; left: -9999px;">selected</span>');
                        }
                    });
                    $shadowRoot.find(".product-card, .product-card-items-wrapper").each(function () {
                        $(this).removeAttr("tabindex");                       
                    });
                    const yourElement = shadowRoot.querySelector(".fs-total-results-text");
                    if (yourElement) {
                        const h2Element = document.createElement("h2");
                        h2Element.textContent = yourElement.textContent;
                        h2Element.className = yourElement.className;
                        h2Element.style.fontSize = "15px";
                        h2Element.style.fontWeight = "500";
                        h2Element.style.fontFamily = 'Helvetica, "Helvetica Neue", Arial, "Lucida Grande", sans-serif';
                        yourElement.parentNode.replaceChild(h2Element, yourElement);
                    }
                    const topCenter = shadowRoot.querySelector(".top-center-container");
                    if (topCenter) {
                        topCenter.removeAttribute("tabindex");
                    }
                    const productsGrid = shadowRoot.querySelector("#products-grid");
                    if (productsGrid) {
                        productsGrid.removeAttribute("tabindex");
                    }
                    const hrTag = shadowRoot.querySelector("hr.divider");
                    if (hrTag) {
                        hrTag.setAttribute("role", "presentation");
                    }
                    $shadowRoot.find(".price").each(function () {
                        $(this).prev().find(".price-container").removeAttr("aria-label");
                        if ($(this).prev(".sr-only").length === 0) {
                            $(this).before('<span class="sr-only" style="position: absolute; left: -9999px;">Sale Price</span>');
                        }
                    });
                    $shadowRoot.find(".price-container").each(function () {
                        $(this).removeAttr("aria-label");
                    });
                    $shadowRoot.find(".compare").each(function () {
                        if ($(this).prev(".sr-only").length === 0) {
                            $(this).before('<span class="sr-only" style="position: absolute; left: -9999px;">Regular Price</span>');
                        }
                        $(this).css({color: "#76767E", opacity: "1"});
                        $(this).removeAttr("aria-label");
                    });

                    $shadowRoot.find(".page-number-item.page-number-item-selected").each(function () {
                        $(this).attr("aria-current", "page");
                    });
                    $shadowRoot.find("a.product-image").each(function () {
                        $(this).attr({ "aria-hidden": "true", tabindex: "-1" });
                    });
                    $shadowRoot.find("div.filters-button-wrapper").each(function () {
                        $(this).attr({ role: "button", tabindex: "0" });
                    });
                    $shadowRoot.find('.pagination-wrapper > span.arrow-button-wrapper a svg[data-icon="arrow-left"]').each(function () {
                        if (!$(this).closest("a").attr("aria-label")) {
                            $(this).closest("a").attr("aria-label", "Previous Page");
                        }
                        // $(this).closest("a").attr("aria-label", "Previous Page");
                    });

                    $shadowRoot.find(".fs-scroll-to-top-button").each(function (index) {
                        var $div = $(this);
                        if (index === 0) {
                            var $button = $("<button>", {
                                text: $div.text(),
                                class: $div.attr("class"),
                                style: $div.attr("style"),
                                "aria-label": "Scroll To Top",
                            });
                            $div.replaceWith($button);
                            $button.on("click", function () {
                                $("html, body").animate({ scrollTop: 0 }, "slow");
                                jQuery("body").attr("tabindex", "0").focus();
                                setTimeout(function () {
                                    jQuery("body").removeAttr("tabindex");
                                }, 2000);
                            });
                            $button.on("keydown", function (event) {
                                if (event.keyCode === 13) {
                                    $("html, body").animate({ scrollTop: 0 }, "slow");
                                    jQuery("body").attr("tabindex", "0").focus();
                                    setTimeout(function () {
                                        jQuery("body").removeAttr("tabindex");
                                    }, 2000);
                                }
                            });
                        } else {
                            $div.remove();
                        }
                    });
                    const $div = $shadowRoot.find(".select__trigger");

                    if ($div.length) {
                        const divClass = $div.attr("class");
                        const divHTML = $div.html();
                        $div.replaceWith(`<button class="${divClass}" type="button" style="background: transparent; border: none;" aria-expanded="false">${divHTML}</button>`);
                    }
                    const $container = $shadowRoot.find(".custom-options.open");
                    if ($container.length) {
                        $container.prev().attr("aria-expanded", "true");
                        $container.find(".custom-option").each(function (index, element) {
                            const $element = $(element);
                            $element.on("keydown", function (e) {
                                if (e.keyCode === 9) {
                                    const isLastElement = index === $container.find(".custom-option").length - 1;
                                    if (isLastElement) {
                                        $container.removeClass("open");
                                        $container.prev().attr("aria-expanded", "false");
                                    }
                                }
                                if (e.shiftKey) {
                                    const isFirstElement = index === 0;
                                    if (isFirstElement) {
                                        $container.removeClass("open");
                                        $container.prev().focus();
                                        $container.prev().attr("aria-expanded", "false");
                                    }
                                }
                                if (e.keyCode === 27) {
                                    $container.removeClass("open");
                                    $container.prev().focus();
                                    $container.prev().attr("aria-expanded", "false");
                                }
                            });
                        });
                    }
                    const $filters = $shadowRoot.find(".filters-container-collapsed");
                    if ($filters.length) {
                        $filters.focus();
                    }

                    function updateTitle() {
                        var pageUrl = window.location.href;
                        var collectionNameMatch = pageUrl.match(/collections\/([^\/?&]+)/);
                        var collectionName = collectionNameMatch && collectionNameMatch[1] ? collectionNameMatch[1].charAt(0).toUpperCase() + collectionNameMatch[1].slice(1) : "Collection";
                        var pageNumberMatch = pageUrl.match(/page=(\d+)/);
                        var pageNumber = pageNumberMatch && pageNumberMatch[1] ? pageNumberMatch[1] : "1";
                        $("title").text(collectionName + " - Page " + pageNumber + " – Shout! Factory");
                    }

                    $(document).ready(function () {
                        updateTitle();
                        $(document).on("click", ".page-number-item", function () {
                            updateTitle();
                        });
                    });
                }
            }

            //
            const productShadowHost = document.querySelector("div.fast-simon-new-upsell-17253816611246332");
            if (productShadowHost) {
                const productShadowRoot = productShadowHost.shadowRoot;
                if (productShadowRoot) {
                    const $productShadowRoot = $(productShadowRoot);
                    $productShadowRoot.find("button.fs-recommendation-button.fs-rec-widget-q46gq3").attr("aria-label", "Next slide");
                    $productShadowRoot.find("button.fs-recommendation-button.fs-rec-widget-q46gq3.arrow-visibility").attr("aria-label", "Previous slide");

                    $productShadowRoot.find(".title-container.fs-recommendation-product-title").each(function () {
                        const $title = jQuery(this);
                        const hrefValue = "";
                        $title.attr("href", hrefValue);
                    });
                    $productShadowRoot.find(".fs-recommendation-product-price").each(function () {
                        if ($(this).prev(".sr-only").length === 0) {
                            $(this).before('<span class="sr-only" style="position: absolute; left: -9999px;">Sale Price</span>');
                        }
                    });

                    $productShadowRoot.find(".compare-price").each(function () {
                        if ($(this).prev(".sr-only").length === 0) {
                            $(this).before('<span class="sr-only" style="position: absolute; left: -9999px;">Regular Price</span>');
                            $(this).css({color: "#76767E", opacity: "1"});
                        }
                    });
                  $productShadowRoot.find(".fs-recommendation-compare-price-container.fs-rec-widget-1qnhg1i").each(function () {
                     $(this).css({color: "#76767E", opacity: "1"});
                  });
                }
            }
        }
        updateAriaLabels();
        // setInterval(updateAriaLabels, 7000);
        function updateArticleAttributes() {
            jQuery(".product .product-item .card").each(function () {
                var titleText = jQuery(this).find("a.card-title.card-title-ellipsis").text().trim();
                jQuery(this)
                    .find("form button.product-form__submit")
                    .attr("aria-label", "Add to cart: " + titleText);
            });
            jQuery(".article-card a.image-zoom").attr({
                tabindex: "-1",
                "aria-hidden": "true",
            });
            jQuery(".halo-item a.adaptive_height").removeAttr("tabindex");
            jQuery(".rebuy-product-block").each(function () {
                jQuery(this).removeAttr("role").removeAttr("aria-label");
                
            });
            let h3Index = 1;
            let aTagIndex = 1;
            jQuery(".featured-blog-block .slick-slider").each(function () {
                var featuredBlogh3 = jQuery(this).find("h3 a span").text().trim();
                var featuredBlogATag = jQuery(this).find(".article-card__footer a").text().trim();
                var h3Id = `featuredblog-${h3Index++}`;
                var aTagId = `view-details-${aTagIndex++}`;
                jQuery(this).find("h3 a").attr("id", h3Id);
                jQuery(this).find(".article-card__footer a").attr("id", aTagId);
                jQuery(this).find(".article-card__footer a").attr("aria-labelledby", `${h3Id} ${aTagId}`);
            });
        }
        updateArticleAttributes();
        // setInterval(updateArticleAttributes, 500);
        let ariaLabelsIntervalId = null;
        let articleAttributesIntervalId = null;

        function startIntervals() {
            if (!ariaLabelsIntervalId) {
                ariaLabelsIntervalId = setInterval(updateAriaLabels, 2000);
            }
            if (!articleAttributesIntervalId) {
                articleAttributesIntervalId = setInterval(updateArticleAttributes, 500);
            }
        }

        function clearAllIntervals() {
            if (ariaLabelsIntervalId) {
                clearInterval(ariaLabelsIntervalId);
                ariaLabelsIntervalId = null;
            }
            if (articleAttributesIntervalId) {
                clearInterval(articleAttributesIntervalId);
                articleAttributesIntervalId = null;
            }
        }

        startIntervals();
        setInterval(clearAllIntervals, 20000);

        ["click", "keypress", "scroll"].forEach((event) => {
            window.addEventListener(event, startIntervals);
        });

        const targetNode = document.querySelector("body");
        if (targetNode) {
            const observer = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === "childList" || mutation.type === "subtree") {
                        updateAriaLabels();
                        updateArticleAttributes();

                        observer.disconnect();
                        break;
                    }
                }
            });
            const config = { childList: true, subtree: true, characterData: true };
            observer.observe(targetNode, config);
        }
    } catch (error) {}
});
